import React from "react";
import AppHeading from "../layout/parts/app-heading";
import AppBody from "../layout/parts/app-body";
import DataTable from "../components/data-table/data-table";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import GenericAddDialog from "./components/dialogs/generic-add-dialog";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../providers/auth-provider";
import isAdmin from "../functions/is-admin";
import { v4 as uuid } from "uuid";
import axios from "../requests/axios";

export default function ManageChannelsPage() {
  const [showAddChannelDialog, setShowAddChannelDialog] = React.useState(false);
  const tableRef = React.useRef();
  const navigate = useNavigate();
  const { user } = useAuth();

  const columns = React.useMemo(
    () => [
      {
        label: "Display Name",
        key: "label",
        value: "label",
        width: 20,
      },
      {
        label: "Name",
        key: "key",
        value: "key",
        width: 25,
      },
      {
        label: "Parent",
        key: "parent_channel_name",
        value: "parent_channel_name",
        width: 20,
      },
      {
        label: "External ID",
        key: "external_id",
        value: "external_id",
        width: 25,
      },
      {
        label: "",
        value: "",
        key: "0",
        width: 10,
        renderValue: (row) => {
          return (
            <span className="data-table__action-cell">
              <span
                className="data-table__action-cell__item data-table__icon"
                onClick={() => navigate(`/admin/channels/${row.channel_id}`)}
              >
                <EditRoundedIcon />
              </span>
            </span>
          );
        },
      },
    ],
    [navigate]
  );

  // admin-only page
  if (!isAdmin(user)) {
    navigate("/");
    return;
  }

  function openNewChannelDialog() {
    setShowAddChannelDialog(true);
  }

  function closeNewChannelDialog() {
    setShowAddChannelDialog(false);
  }

  function refreshTable() {
    tableRef.current?.refreshList();
  }

  function createChannel(payload) {
    return axios.post(`api/channels`, payload);
  }

  return (
    <React.Fragment>
      <AppHeading
        title="Manage Channels"
        subtitle="Add Channels using the button on the top right"
        rightActions={[
          {
            onClick: openNewChannelDialog,
            balloonLabel: "Add Channel",
            icon: AddCircleRoundedIcon,
          },
        ]}
      />

      <AppBody>
        <div className="channels-page">
          <DataTable url={"/api/channels"} columns={columns} ref={tableRef} />
        </div>
      </AppBody>
      <GenericAddDialog
        onSubmit={createChannel}
        onSuccess={() => refreshTable()}
        onClose={closeNewChannelDialog}
        isOpen={showAddChannelDialog}
        title="Add New Channel"
        successMessage="Channel created successfully"
        errorMessage="Error occurred while creating Channel"
        fields={[
          {
            type: "text",
            label: "Display Name",
            name: "label",
            required: true,
          },
          {
            type: "text",
            label: "Name",
            name: "key",
            required: true,
          },
          {
            type: "text",
            label: "External ID",
            name: "external_id",
            required: true,
          },
          {
            type: "select",
            label: "Channel Type",
            name: "channel_type",
            required: true,
            options: [
              { label: "Linear", value: "linear" },
              { label: "AVOD", value: "avod" },
            ],
          },
          {
            type: "text",
            label: "Parent Channel Name (optional)",
            name: "parent_channel_name",
            required: false,
          },
        ]}
        key={`add-dialog-${uuid()}`}
      />
    </React.Fragment>
  );
}
